exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:fibraultrabold_it;font-display:block;src:url(\"/src/fonts/fibra/los_andes_-_fibra_ultrabold_it-webfont.woff2\") format(\"woff2\"),url(\"/src/fonts/fibra/los_andes_-_fibra_ultrabold_it-webfont.woff\") format(\"woff\");font-weight:400;font-style:normal}#background{top:0;left:0;height:100vh;width:100%;position:fixed;overflow:hidden}.background-fallback{position:absolute;height:100%;width:100%;background-image:url(\"/src/assets/marble_bg_tiny.jpg\");background-position:50%;background-size:cover;display:none}@media screen and (max-width:1200px){.background-fallback{display:block}}#background-canvas{position:absolute;height:100%;width:100%}@media screen and (max-width:1200px){#background-canvas{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4186b43f","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Background.vue
// module id = 23
// module chunks = 0